<template>
  <section class="pdp">
    <div v-if="b2bGuardProductDisplay">
    <div class="pdp__main">
      <div class="pdp__main-width-container" :style="containerStyles">
        <breadcrumbs v-if="$mq === 'mobile'" :collection="collection" :product="product" />
        <product-gallery
          v-bind="$props"
          v-model="variant"
        ></product-gallery>
        <product-form
          v-bind="$props"
          v-model="variant"
          :prices="prices"
          :display-vendor="displayVendor"
          :pseudo-variants="pseudoVariants"
        ></product-form>
      </div>
    </div>

    <div class="pdp__more-details">
      <product-more-details :custom-fields="customFields"></product-more-details>
    </div>

-    <div class="pdp__three-column-info" v-if="$mq === 'mobile'">
      <div class="product-form__detail-icons-container"  v-if="$mq === 'mobile'">
        <div class="product-form__detail-icons" >
            <div class="product-form__detail-icon" v-for="(valueProp, i) in badgesWithTitle" :key="i">
              <img class="product-form__detail-icon-icon" :src="valueProp.icon">
              <span class="product-form__detail-icon-title"> {{valueProp.title}}</span>
            </div>
          </div>
        </div>
-    </div>

    <div class="pdp__how-to-use">
      <product-how-to-use :custom-fields="customFields" />
    </div>
    <div class="pdp__skin-experience" v-if="customFields.skin_experience_active==1" >
      <product-skin-experience :custom-fields="customFields" />
    </div>
    <div
      class="pdp__reviews pdp--side-padded-mobile container"
      id="pdp-reviews"
      v-if="!settings.hideReviews"
    >
      <product-reviews v-bind="$props" :v-model="variant"></product-reviews>
    </div>
    <div
      class="pdp__product-recs"
      v-if="recommendedProducts.length"
    >
      <featured-collection
        :enableSimpleTile="true"
        :enableSimpleTileCta="true"
        :featuredCollection="{
          shopAllBtn: 'Visitors also viewed',
          heading: 'You May Also Like',
          products: recommendedProducts,
          marginBottom: 0,
          enableCta: !!settings.overrideCollectionUrl,
          ctaLink: settings.overrideCollectionUrl,
          ctaLayout: 'link link--primary'
        }"
      />
    </div>
  </div>
  </section>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex';
import ProductGallery from './ProductGallery.vue'
import ProductForm from './ProductForm.vue'
import ProductBreadcrumbs from './ProductBreadcrumbs.vue'
import ProductMoreDetails from './ProductMoreDetails.vue'
import ProductReviews from './ProductReviews.vue'
import ProductHowToUse from './ProductHowToUse.vue';
import ProductThreeColumnInfo from './ProductThreeColumnInfo.vue';
import ProductSkinExperience from './ProductSkinExperience.vue';
import FeaturedCollection from '@/scripts/components/sections/FeaturedCollection.vue'
import AboutImageBannerBlock from '@/scripts/components/sections/AboutImageBannerBlock.vue'
import {
  isColorClass,
  sumVariantPrices,
  isHiddenProduct,
  imageSize
} from '@/scripts/helpers/util'
import ValueProps from '@/scripts/components/footer/FooterValueProps.vue'
import SuperCollectionLinear from '@/scripts/components/pages/SuperCollection/SuperCollectionLinear.vue'
import Breadcrumbs from '@/scripts/components/navigation/Breadcrumbs.vue';
import prop from 'lodash/property'

export default {
  name: 'ProductDisplay',
  components: {
    ProductGallery,
    ProductForm,
    ProductBreadcrumbs,
    ProductMoreDetails,
    ProductReviews,
    ProductHowToUse,
    ProductThreeColumnInfo,
    ProductSkinExperience,
    FeaturedCollection,
    AboutImageBannerBlock,
    ValueProps,
    SuperCollectionLinear,
    Breadcrumbs,
  },
  props: {
    collection: Object,
    product: Object,
    customFields: Object,
    settings: Object,
    magnetProduct: Object,
    productTileTextAlignment: String,
    displayVendor: Boolean,
    brand: Array,
  },
  data () {
    return {
      isWholesale: this.product.tags.includes('wholesale'),
      isB2B: window.bvaccel.b2b,
      variant: this.product.selected_or_first_available_variant
        ? this.product.variants.filter(
            variant =>
              variant.id === this.product.selected_or_first_available_variant.id
          )[0]
        : {},
      recommendedProducts: this.settings.overrideRelatedProducts || [],
      reviewSource: window.bvaccel && window.bvaccel.reviewSource,
      pseudoVariants: null
    }
  },
  created() {
    this.identifyUpsell();
  },
  mounted () {
    if(!(this.isWholesale ? this.isB2B : true)){
      window.location.href = '/404';
    }
    if (this.recommendedProducts.length <= 0) {
      // get recommended products
      axios
        .get(
          `/recommendations/products?section_id=recommended-products--json&product_id=${this.product.id}&limit=8`,
          { withCredentials: true }
        )
        .then(res => {
          // get json from inside recommended-section div and parse it.
          if (res && res.data && res.data.length) {
            const temp = document.createElement('div')
            temp.innerHTML = res.data
            const data = JSON.parse(temp.firstChild.innerText.trim())
            if (data.products instanceof Array) {
              this.recommendedProducts = data.products.filter(
                prod => prod.available && !isHiddenProduct(prod)
              )
            }
          }
        })
        .catch(e =>
          console.error('error fetching recommended products', e.message)
        )
    }

    // get "variant" products
    axios
      .get(
        `/collections/all/${
          this.product.variants[0].sku.split('-')[0]
        }?view=json`
      )
      .then(res => {
        this.pseudoVariants = res.data.products.map((item) => ({
          id: item.id,
          title: item.title,
          handle: item.handle,
          url: item.url,
          available: item.available,
          thumbnailImage: item.thumbnailImage ? item.thumbnailImage : item.images[0] && this.imageSize(item.images[0].src, '100x100')
        }))
      })
      .catch(err => {
        console.error('error fetching pseudo variants', err.message)
      })
  },
  methods: {
    imageSize,
    /**
     * @desc Prefer the scopedUpsell to the globalUpsell.
     */
    identifyUpsell() {
      const { globalUpsell, scopedUpsell } = this.product;
      const upsell = scopedUpsell || globalUpsell;
      if (!upsell) return;
      this.$store.dispatch('upsell/setUpsell', upsell);
    },
  },
  computed: {
    ...mapState({
      difference: ({ navbar }) => navbar.difference,
    }),
    containerStyles() {
      if (this.$mq !== 'mobile') return {}
      return {
        paddingTop: `${this.difference}px`,
      }
    },
    /** convert metafield client readable colors to class names  */
    transformedValuePropsSettings () {
      const transforms = [
        { key: 'backgroundColor', prefix: 'bg' },
        { key: 'borderColor', prefix: 'border' },
        { key: 'dividerColor', prefix: 'bg' },
        { key: 'textColor', prefix: 'color' }
      ]
      const newValues = {}
      for (const tran of transforms) {
        const value = this.settings.valueProps.settings[tran.key]
        if (!isColorClass(value)) {
          newValues[tran.key] =
            tran.prefix + '-' + this.$store.state.metafieldColorMap[value]
        }
      }

      return Object.assign(this.settings.valueProps.settings, newValues)
    },

    featuredCollectionsSettings () {
      return {
        heading: this.settings.featuredCollections.heading,
        headingColor: this.settings.featuredCollections.headingColor,
        backgroundColor: this.settings.featuredCollections.backgroundColor,
        linearArray: this.settings.featuredCollections.blocks
      }
    },
    prices () {
      const prices = sumVariantPrices(this.variant, this.selectedMagnetVariant)
      return prices
    },
    hideValueProps () {
      return (
        this.settings.valueProps.settings.hide ||
        !this.settings.valueProps.blocks
          .slice(0, 2)
          .every(prop('settings.icon'))
      )
    },
    badgesWithTitle () {
      let detailIconTitles = this.customFields.title ? this.customFields.title.split('|###|') : [];
      let detailIconIcons = this.customFields.icon ? this.customFields.icon.split('|###|') : [];
      return detailIconIcons.map((icon, i) => ({
        title: (detailIconTitles[i]) ? detailIconTitles[i] : '',
        icon: detailIconIcons[i]
      }));
    },
    bannerData () {
      const textColor = /light/i.test(this.customFields.banner_text_color)
        ? 'color-white'
        : 'color-black'
      const overlayColor = /light/i.test(this.customFields.banner_overlay_color)
        ? 'bg-white'
        : 'bg-black'
      const overlayOpacity = this.customFields.banner_overlay_opacity
        ? Math.round(parseInt(this.customFields.banner_overlay_opacity))
        : 0 // 1-9

      return {
        enableCta: false,
        ctaUrl: '',
        headingColor: textColor,
        heading: this.customFields.banner_header,
        subHeadingColor: textColor,
        subHeading: this.customFields.banner_subheading,
        copyColor: textColor,
        ctaLayout: null,
        ctaText: null,
        heading: this.customFields.banner_header,
        copy: this.customFields.banner_body_copy,
        overlayEnable: true,
        imageMobileEnable: true,
        overlayColor: overlayColor,
        overlayOpacity: overlayOpacity,
        mobileBgColor: 'bg-white',
        layoutVertical: 'middle',
        layoutHorizontal: 'center',
        imageMobile:
          this.customFields.banner_mobile_image ||
          this.customFields.banner_desktop_image,
        image: this.customFields.banner_desktop_image
      }
    },
    b2bGuardProductDisplay() {
      return this.isWholesale ? this.isB2B : true;
    },
  }
}
</script>

<style lang="scss" scoped>
.pdp {

  @include mobile-only {
    margin-top: -54px;
  }
  &__main {
    max-width: 100%;
    margin: 0 auto;
    padding-bottom: 48px;
    @include mobile-only {
      padding-bottom: 0;
    }
  }

  .section-padded {
    padding-top: 0;
  }

  .margin-bottom {
    margin-bottom: 20px;

    @include tablet-up {
      margin-bottom: 56px;
    }
  }

  &__main + * {
    // make sure the next section doesn't float up into the product form/gallery space
    clear: both;
  }

  &__main-width-container {
    max-width: 100%;
    margin: 0 auto;
    position: relative;
  }

  &--flex-row {
    display: flex;
    justify-content: space-between;
  }

  &__sku {
    margin-right: 16px;
    color: $color-off-black;
    display: inline-block;
  }

  &__tech-specs {
    @include tablet-up {
      padding-left: $grid-gutter;
      padding-right: $grid-gutter;
    }
  }

  @include mobile-only {
    .hero-banner__content * {
      color: $color-black !important;
    }
  }

  &__product-recs .container {
    padding: 0;
  }

  // Footer overrides
  /deep/ .footer-value-props-container,
  /deep/ .footer-value-props-container .footer-value-prop {
    border: none !important;
  }

  /deep/ .footer-value-prop__title {
    @include h6-tablet;
  }

  /deep/ .footer-value-prop__icon {
    max-width: 100px;
  }

  /deep/ .footer-value-prop__text {
    @include mobile-only {
      margin-bottom: 0;
    }
  }

  /deep/
    .footer-value-prop__pagination
    .swiper-pagination-bullet:not(.swiper-pagination-bullet-active) {
    background: $color-grey;
  }

  /deep/ .footer-value-prop-heading {
    margin-bottom: 24px;
    @include h3-mobile;

    @include tablet-up {
      @include h4-tablet;
      margin-bottom: 48px;
    }
  }
}

.pdp {
  /deep/ .super-collection-linear__tile {
    max-width: 200px;
  }

  /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
    color: $color-brand-primary;
  }

  @include mobile-only {
    padding-bottom: 24px;
  }

  &--wrapper {
    @include mobile-only {
      padding-bottom: 24px;
    }
  }

  .hero__background {
    @include mobile-only {
      display: none;
    }

    bottom: 120px;
  }

  & > .container {
    margin-top: 24px;

    @include tablet-up {
      padding: 56px $grid-gutter;
    }
  }

  @include mobile-only {
    &--side-padded-mobile {
      margin-left: 15px;
      margin-right: 15px;
      width: calc(100% - 30px);
    }
  }

  @include tablet-up {
    &__main {
      padding: 0 0 56px;
      font-size: 0;
    }

    /deep/ .super-collection-linear__heading {
      margin-bottom: 40px;
    }

    &__accordions {
      width: 50%;
    }

    &__reviews {
      max-width: 1075px;
    }

    @include desktop-up {
      &__accordions {
        width: 36%;
        padding-left: 120px;
      }
    }

    &__sticky-container {
      position: relative;
    }
  }

  @include desktop-up {
    &__product-recs .controls-container {
      display: none !important;
    }
  }
}

/deep/ #BVRRContainer {
  padding-bottom: 56px;
}

@media screen and (min-width: 1400px) {
  .pdp--sidebar-active {
    .pdp__main .pdp__main-width-container {
      max-width: 1400px;
      padding-right: 240px;
      margin: 0 auto;
    }

    /deep/ .pdp__main .product-rec-sidebar {
      display: absolute;
      right: 0;
      top: 0;
      display: block;
    }

    /deep/ .pdp__main .product-form,
    /deep/ .pdp__main .product-details,
    /deep/ .pdp__main .pdp-gallery {
      width: 50%;
    }
  }
}
</style>
